<template>
  <div>
    <settings-card :config="config">
      <el-button
        type="text"
        @click="settings">去设置</el-button>
    </settings-card>
    <warehouse-management-modal
      ref="management"
      :enable="enable"
      :operType="config.operType"
      :title="config.text" />
  </div>
</template>
<script>
import SettingsCard from '../settings-card.vue'
import WarehouseManagementModal from './warehouse-management-modal.vue'
export default {
  name: 'WarehouseManagementCard',
  components: { SettingsCard, WarehouseManagementModal },
  props: {
    enable: { type: Boolean, default: true },
    config: { type: Object, default() { return {} } }
  },
  methods: {
    settings() {
      this.$refs.management.fetch()
    }
  }
}
</script>
